// const logoUrl = "https://hclsw-id-resources.s3.amazonaws.com/hclsw-hz-color-md2x.png";
const logoUrl = "https://hclsw-id-resources.s3.amazonaws.com/hclsw-vt-color-lg2x.png";

function FormHeader() {
  return (
    <div className="okta-sign-in-header auth-header">
      <img src={logoUrl} className="auth-org-logo" alt="HCLSoftware Logo" />
      <div data-type="beacon-container" className="beacon-container"></div>
    </div>
  )
}

export default FormHeader;
